// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: vehicle/infrastructure/flight_deck/lcmtypes/battery_prediction_t.lcm

import { float } from "@skydio/lcm/src/types";
import { int64_t } from "@skydio/lcm/src/types";

import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmMsg from "@skydio/lcm/src/lcm";
import ReflectionMeta from "@skydio/lcm/src/reflection";

export class battery_prediction_t extends LcmMsg {

  private static _hash = Long.fromString("16275215357052559387", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (battery_prediction_t._packed_fingerprint === undefined) {
      battery_prediction_t._packed_fingerprint = battery_prediction_t._get_hash_recursive([]);
    }
    return battery_prediction_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(battery_prediction_t) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = battery_prediction_t._hash;
    return tmp_hash.shl(1).add(tmp_hash.shru(63));
  }

  /** @internal */
  public static override _reflection_meta: ReflectionMeta = {
    utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    predicted_low_land_utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    predicted_critical_utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    predicted_battery_hot_utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    battery_percentage: { kind: "primitive", type: Number, typeStr: "float" },
    battery_charging: { kind: "primitive", type: Boolean, typeStr: "boolean" },
    true_battery_percentage: { kind: "primitive", type: Number, typeStr: "float" },
    predicted_return_percentage: { kind: "primitive", type: Number, typeStr: "float" },
    predicted_critical_percentage: { kind: "primitive", type: Number, typeStr: "float" },
    predicted_critical_utime_remaining: { kind: "primitive", type: Number, typeStr: "int64_t" },
    predicted_battery_hot_utime_remaining: { kind: "primitive", type: Number, typeStr: "int64_t" },
    elapsed_flight_time_s: { kind: "primitive", type: Number, typeStr: "float" },
    battery_temperature_deg_c: { kind: "primitive", type: Number, typeStr: "float" },
    predicted_time_until_rtx_s: { kind: "primitive", type: Number, typeStr: "float" },
    predicted_time_until_shutdown_s: { kind: "primitive", type: Number, typeStr: "float" },
    flight_envelope_power_limit: { kind: "primitive", type: Number, typeStr: "float" },
    fcc_gas_gauge: { kind: "primitive", type: Number, typeStr: "float" },
    remcap_gas_gauge: { kind: "primitive", type: Number, typeStr: "float" },
    fcc_estimated: { kind: "primitive", type: Number, typeStr: "float" },
    remcap_estimated: { kind: "primitive", type: Number, typeStr: "float" },
    voltage_v: { kind: "primitive", type: Number, typeStr: "float" },
    current_a: { kind: "primitive", type: Number, typeStr: "float" },
  };

  public utime: int64_t;
  public predicted_low_land_utime: int64_t;
  public predicted_critical_utime: int64_t;
  public predicted_battery_hot_utime: int64_t;
  public battery_percentage: float;
  public battery_charging: boolean;
  public true_battery_percentage: float;
  public predicted_return_percentage: float;
  public predicted_critical_percentage: float;
  public predicted_critical_utime_remaining: int64_t;
  public predicted_battery_hot_utime_remaining: int64_t;
  public elapsed_flight_time_s: float;
  public battery_temperature_deg_c: float;
  public predicted_time_until_rtx_s: float;
  public predicted_time_until_shutdown_s: float;
  public flight_envelope_power_limit: float;
  public fcc_gas_gauge: float;
  public remcap_gas_gauge: float;
  public fcc_estimated: float;
  public remcap_estimated: float;
  public voltage_v: float;
  public current_a: float;

  public override decode(byte_array: Uint8Array): battery_prediction_t {
    const decoder = new Decoder(new DataView(
      byte_array.buffer, byte_array.byteOffset, byte_array.byteLength
    ));
    const hash = decoder.decode_hash();
    if (!hash.equals(battery_prediction_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, battery_prediction_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  public override decode_one(decoder: Decoder): battery_prediction_t {
    this.utime = decoder.decode_int64_t();
    this.predicted_low_land_utime = decoder.decode_int64_t();
    this.predicted_critical_utime = decoder.decode_int64_t();
    this.predicted_battery_hot_utime = decoder.decode_int64_t();
    this.battery_percentage = decoder.decode_float();
    this.battery_charging = decoder.decode_boolean();
    this.true_battery_percentage = decoder.decode_float();
    this.predicted_return_percentage = decoder.decode_float();
    this.predicted_critical_percentage = decoder.decode_float();
    this.predicted_critical_utime_remaining = decoder.decode_int64_t();
    this.predicted_battery_hot_utime_remaining = decoder.decode_int64_t();
    this.elapsed_flight_time_s = decoder.decode_float();
    this.battery_temperature_deg_c = decoder.decode_float();
    this.predicted_time_until_rtx_s = decoder.decode_float();
    this.predicted_time_until_shutdown_s = decoder.decode_float();
    this.flight_envelope_power_limit = decoder.decode_float();
    this.fcc_gas_gauge = decoder.decode_float();
    this.remcap_gas_gauge = decoder.decode_float();
    this.fcc_estimated = decoder.decode_float();
    this.remcap_estimated = decoder.decode_float();
    this.voltage_v = decoder.decode_float();
    this.current_a = decoder.decode_float();
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    let total_size = 0;
    total_size += 8;
    total_size += 8;
    total_size += 8;
    total_size += 8;
    total_size += 4;
    total_size += 1;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 8;
    total_size += 8;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    return total_size;
  }

  public override encode(): ArrayBufferLike {
    const encoder = new Encoder(8 + this._get_encoded_size()); // hash + rest
    encoder.encode_hash(battery_prediction_t._get_packed_fingerprint());
    this.encode_one(encoder);

    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_int64_t(this.utime);
    encoder.encode_int64_t(this.predicted_low_land_utime);
    encoder.encode_int64_t(this.predicted_critical_utime);
    encoder.encode_int64_t(this.predicted_battery_hot_utime);
    encoder.encode_float(this.battery_percentage);
    encoder.encode_boolean(this.battery_charging);
    encoder.encode_float(this.true_battery_percentage);
    encoder.encode_float(this.predicted_return_percentage);
    encoder.encode_float(this.predicted_critical_percentage);
    encoder.encode_int64_t(this.predicted_critical_utime_remaining);
    encoder.encode_int64_t(this.predicted_battery_hot_utime_remaining);
    encoder.encode_float(this.elapsed_flight_time_s);
    encoder.encode_float(this.battery_temperature_deg_c);
    encoder.encode_float(this.predicted_time_until_rtx_s);
    encoder.encode_float(this.predicted_time_until_shutdown_s);
    encoder.encode_float(this.flight_envelope_power_limit);
    encoder.encode_float(this.fcc_gas_gauge);
    encoder.encode_float(this.remcap_gas_gauge);
    encoder.encode_float(this.fcc_estimated);
    encoder.encode_float(this.remcap_estimated);
    encoder.encode_float(this.voltage_v);
    encoder.encode_float(this.current_a);
  }

  constructor(init?: {utime?: int64_t, predicted_low_land_utime?: int64_t, predicted_critical_utime?: int64_t, predicted_battery_hot_utime?: int64_t, battery_percentage?: float, battery_charging?: boolean, true_battery_percentage?: float, predicted_return_percentage?: float, predicted_critical_percentage?: float, predicted_critical_utime_remaining?: int64_t, predicted_battery_hot_utime_remaining?: int64_t, elapsed_flight_time_s?: float, battery_temperature_deg_c?: float, predicted_time_until_rtx_s?: float, predicted_time_until_shutdown_s?: float, flight_envelope_power_limit?: float, fcc_gas_gauge?: float, remcap_gas_gauge?: float, fcc_estimated?: float, remcap_estimated?: float, voltage_v?: float, current_a?: float }) {
    super();
    this.utime = 0;
    this.predicted_low_land_utime = 0;
    this.predicted_critical_utime = 0;
    this.predicted_battery_hot_utime = 0;
    this.battery_percentage = 0.0;
    this.battery_charging = false;
    this.true_battery_percentage = 0.0;
    this.predicted_return_percentage = 0.0;
    this.predicted_critical_percentage = 0.0;
    this.predicted_critical_utime_remaining = 0;
    this.predicted_battery_hot_utime_remaining = 0;
    this.elapsed_flight_time_s = 0.0;
    this.battery_temperature_deg_c = 0.0;
    this.predicted_time_until_rtx_s = 0.0;
    this.predicted_time_until_shutdown_s = 0.0;
    this.flight_envelope_power_limit = 0.0;
    this.fcc_gas_gauge = 0.0;
    this.remcap_gas_gauge = 0.0;
    this.fcc_estimated = 0.0;
    this.remcap_estimated = 0.0;
    this.voltage_v = 0.0;
    this.current_a = 0.0;

    // optionally override default values
    if (!init) {
      return;
    }
    this.utime = init.utime || this.utime;
    this.predicted_low_land_utime = init.predicted_low_land_utime || this.predicted_low_land_utime;
    this.predicted_critical_utime = init.predicted_critical_utime || this.predicted_critical_utime;
    this.predicted_battery_hot_utime = init.predicted_battery_hot_utime || this.predicted_battery_hot_utime;
    this.battery_percentage = init.battery_percentage || this.battery_percentage;
    this.battery_charging = init.battery_charging || this.battery_charging;
    this.true_battery_percentage = init.true_battery_percentage || this.true_battery_percentage;
    this.predicted_return_percentage = init.predicted_return_percentage || this.predicted_return_percentage;
    this.predicted_critical_percentage = init.predicted_critical_percentage || this.predicted_critical_percentage;
    this.predicted_critical_utime_remaining = init.predicted_critical_utime_remaining || this.predicted_critical_utime_remaining;
    this.predicted_battery_hot_utime_remaining = init.predicted_battery_hot_utime_remaining || this.predicted_battery_hot_utime_remaining;
    this.elapsed_flight_time_s = init.elapsed_flight_time_s || this.elapsed_flight_time_s;
    this.battery_temperature_deg_c = init.battery_temperature_deg_c || this.battery_temperature_deg_c;
    this.predicted_time_until_rtx_s = init.predicted_time_until_rtx_s || this.predicted_time_until_rtx_s;
    this.predicted_time_until_shutdown_s = init.predicted_time_until_shutdown_s || this.predicted_time_until_shutdown_s;
    this.flight_envelope_power_limit = init.flight_envelope_power_limit || this.flight_envelope_power_limit;
    this.fcc_gas_gauge = init.fcc_gas_gauge || this.fcc_gas_gauge;
    this.remcap_gas_gauge = init.remcap_gas_gauge || this.remcap_gas_gauge;
    this.fcc_estimated = init.fcc_estimated || this.fcc_estimated;
    this.remcap_estimated = init.remcap_estimated || this.remcap_estimated;
    this.voltage_v = init.voltage_v || this.voltage_v;
    this.current_a = init.current_a || this.current_a;
  }
}